
import { Component, Vue } from 'vue-property-decorator'
import { colorList } from '@/core/pageConfig'
import { addGoodsTag, modifyGoodsTag } from "@/api/commodity";
import { Getter } from "vuex-class";

interface TagOption {
  tagId?: string,
  tagName: string,
  companyId: string,
  tagColor: string,
}

@Component
export default class addLabel extends Vue {
  @Getter companyId!: string

  labelWidth = 120;
  isRefresh = 0

  formData: TagOption = {
    companyId: '',
    tagName: '',
    tagColor: ''
  }
  colors: string[] = colorList

  visible = false

  created () {
    // if (this.$isEdit) {
    //   const data = JSON.parse(this.$route.query.data as string)
    //   this.formData.tagId = data.tagId
    //   this.formData.tagColor = data.tagColor
    //   this.formData.tagName = data.tagName
    // }
  }

  showModal () {
    this.resetData()
    this.visible = true;
    (this.$refs.handleForm as any).resetValidation()
  }
  resetData () {
    this.formData.tagName = ''
    this.formData.tagColor = ''
  }

  addSure () {
    (this.$refs.handleForm as any).validate().then(() => {
      addGoodsTag(this.formData).then(() => {
        this.$toast.success(`商品标签新增成功！`);
        // this.$router.back()
        this.$emit('on-save')
        this.handleCancel()
      })
    })
  }

  changeColor (val: string) {
    this.formData.tagColor = val
  }

  handleCancel () {
    this.visible = false
  }
}
